import { SalaryData } from './offers.types';

export enum RequisitionJobCompareFieldKey {
  Department = 'department',
  RecruiterId = 'recruiter_id',
  HiringManagerId = 'hiring_manager_id',
  CountryName = 'country_name',
  StateName = 'state_name',
  City = 'city',
  Street = 'street',
  Remote = 'remote',
  EmploymentType = 'employment_type',
  Category = 'category',
  Education = 'education',
  Experience = 'experience',
  MinHoursPerWeek = 'min_hours_per_week',
  MaxHoursPerWeek = 'max_hours_per_week',
  Salary = 'salary',
  LocationIds = 'location_ids',
  WorkModel = 'work_model',
}

export interface CompareFieldData {
  field: RequisitionJobCompareFieldKey;
  isEqual: boolean;
  offer: string | string[] | number | number[] | boolean | SalaryData | null;
  requisition: string | string[] | number | number[] | boolean | SalaryData | null;
}

export type OpeningAssignment = {
  openingId: number;
  placementId: number;
};
